import {
  ArrowLeftOutlined,
  CloseOutlined,
  PlusOutlined,
  UnlockOutlined,
} from "@ant-design/icons";
import { Button } from "antd";
import { inicialNome } from "./chatFormat";
import { ChatLista } from "./ChatLista";
import { ChatThread } from "./ChatThread";
import { ChatNovaConversa } from "./ChatNovaConversa";
import { ChatLiberacoes } from "./ChatLiberacoes";

export const ChatPainel = ({
  user,
  master,
  vista,
  conversas,
  filtroLista,
  conversaAtual,
  mensagens,
  texto,
  enviando,
  contatos,
  buscaContato,
  carregandoContatos,
  instituicoes,
  instituicaoContato,
  fixadas,
  onFechar,
  onVoltar,
  onNova,
  onLiberacoes,
  onFiltrarLista,
  onAbrirConversa,
  onFixarConversa,
  onDesafixarConversa,
  onTexto,
  onEnviar,
  onFixar,
  onDesafixar,
  onBuscarContato,
  onInstituicaoContato,
  onSelecionarContato,
}) => {
  const titulo =
    vista === "thread"
      ? conversaAtual?.contato?.nome || "Conversa"
      : vista === "nova"
      ? "Nova conversa"
      : vista === "liberacoes"
      ? "Liberações"
      : "Conversas";

  return (
    <section className="chat-painel" role="dialog" aria-label="Chat OiSol">
      <header className="chat-painel__cabecalho">
        {vista !== "lista" ? (
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            onClick={onVoltar}
            aria-label="Voltar"
          />
        ) : (
          <span className="chat-avatar" aria-hidden>
            {inicialNome(user?.nome_completo)}
          </span>
        )}
        <div className="chat-painel__titulo">
          <strong>{titulo}</strong>
          {vista === "lista" && <span>OiSol</span>}
        </div>
        {vista === "lista" && (
          <>
            {master && (
              <Button
                type="text"
                icon={<UnlockOutlined />}
                onClick={onLiberacoes}
                aria-label="Liberações"
              />
            )}
            <Button
              type="text"
              className="chat-painel__iniciar"
              icon={<PlusOutlined />}
              onClick={onNova}
              aria-label="Iniciar Chat"
            >
              Iniciar Chat
            </Button>
          </>
        )}
        <Button
          type="text"
          icon={<CloseOutlined />}
          onClick={onFechar}
          aria-label="Fechar chat"
        />
      </header>
      <div className="chat-corpo">
        {vista === "lista" && (
          <ChatLista
            conversas={conversas}
            filtro={filtroLista}
            onFiltrar={onFiltrarLista}
            onAbrir={onAbrirConversa}
            onFixar={onFixarConversa}
            onDesafixar={onDesafixarConversa}
          />
        )}
        {vista === "thread" && (
          <ChatThread
            user={user}
            mensagens={mensagens}
            fixadas={fixadas}
            texto={texto}
            enviando={enviando}
            onTexto={onTexto}
            onEnviar={onEnviar}
            onFixar={onFixar}
            onDesafixar={onDesafixar}
          />
        )}
        {vista === "nova" && (
          <ChatNovaConversa
            contatos={contatos}
            instituicoes={instituicoes}
            busca={buscaContato}
            instituicao={instituicaoContato}
            carregando={carregandoContatos}
            onBuscar={onBuscarContato}
            onInstituicao={onInstituicaoContato}
            onSelecionar={onSelecionarContato}
          />
        )}
        {vista === "liberacoes" && <ChatLiberacoes />}
      </div>
    </section>
  );
};
